/**
 * Datepicker.
 */
window.datepicker = function() {
    $(".datepicker").flatpickr({
        allowInput: true,
        /* dateFormat: datepicker_format ? datepicker_format : "d-m-Y", */
        dateFormat: "d-m-Y"
    });
};
